import React from 'react';
import PropTypes from 'prop-types';
import { getText } from 'src/utils/i18n';
import classnames from 'classnames';
import safeLog from '@alife/bc-safe-log';
import './index.scss';

const TIP_COUNTRIES = [
  'SE',
  'LU',
  'LT',
  'LV',
  'SI',
  'US',
  'SK',
  'BG',
  'BE',
  'FR',
  'RO',
  'FI',
  'GR',
  'AT',
  'PT',
  'MT',
  'IE',
  'NL',
  'HU',
  'PL',
  'HR',
  'IT',
  'EE',
  'DE',
  'DK',
  'ES',
  'CY',
  'CZ',
];
const KEY = 'detail-top-notice-close';

export default class EpidemicBanner extends React.PureComponent {
  static propTypes = {
    isEpidemicCertainty: PropTypes.bool,
    ipCountry: PropTypes.string,
    productIsMarketGoods: PropTypes.bool,
    productIsHang: PropTypes.bool,
    companyRegisterCountry: PropTypes.string,
    productId: PropTypes.number,
    i18n: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const { ipCountry } = props;
    const isShowMaskTipInCountry = TIP_COUNTRIES.indexOf(ipCountry) > -1;
    const shouldHide = !!localStorage.getItem(KEY);

    this.state = {
      isShowMaskTipInCountry,
      visible: !shouldHide,
    };
  }

  close = () => {
    const { productId } = this.props;
    localStorage.setItem(KEY, 'hide');
    safeLog(
      '/sc.details.topNoticeClose',
      'CLK',
      `productId=${productId}`,
      'GET',
    );
    this.setState({
      visible: false,
    });
  };

  render() {
    const { isShowMaskTipInCountry, visible } = this.state;
    const {
      i18n,
      productIsMarketGoods,
      productIsHang,
      companyRegisterCountry,
      isEpidemicCertainty,
    } = this.props;

    if (isEpidemicCertainty && isShowMaskTipInCountry) {
      return (
        <div
          className="detail-top-notice detail-top-notice-mask"
          style={{
            background: '#fff',
            boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.12)',
          }}
        >
          <p>
            <img
              src="//img.alicdn.com/tfs/TB1p093y7L0gK0jSZFtXXXQCXXa-20-20.svg"
              alt="notice"
            />
            <strong>{getText(i18n, 'detail202003-FAQ-title')}</strong>
            <span>{getText(i18n, 'detail202003-MASK-content')}</span>
            <span className="detail-top-notice-detail">
              {getText(i18n, 'detail202003-MASK-detail')}
            </span>
          </p>
        </div>
      );
    } else if (
      productIsMarketGoods &&
      (companyRegisterCountry === 'CN' ||
        companyRegisterCountry === 'HK' ||
        companyRegisterCountry === 'TW')
    ) {
      // 否则走规格品疫情提示逻辑
      return (
        <div
          className={classnames('detail-top-notice', {
            'detail-top-notice-buynow': productIsHang && productIsMarketGoods,
            'detail-top-notice-close': !visible,
          })}
          style={{
            background: '#fff',
            boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.12)',
          }}
        >
          <p>
            <img
              src="//img.alicdn.com/tfs/TB1KFSav1T2gK0jSZFvXXXnFXXa-20-20.svg"
              alt="notice"
            />
            <strong>{getText(i18n, 'detail202003-FAQ-title')}</strong>
            <span>{getText(i18n, 'detail202003-FAQ-content')}</span>
            <img
              src="https://img.alicdn.com/tfs/TB1GKrtwrr1gK0jSZR0XXbP8XXa-12-12.svg"
              alt="close"
              className="top-notice-close-btn"
              onClick={this.close}
              style={{
                float: 'right',
                marginTop: 4,
                cursor: 'pointer',
              }}
            />
          </p>
        </div>
      );
    }

    return null;
  }
}
